export default __webpack_public_path__ + "static/media/cat.af1ef79e.webp";